import React from "react";

const Table = ({ tableTitle, report, selectedDate }) => {
  const column = Object.keys(report[0]);
  console.log(column);

  const filterColumn = column.filter((each) => {
    if (tableTitle.includes(each)) {
      return each;
    }
  });

  return (
    <>
      <div className="table-responsive px-2 mt-2">
        <table className="table table-striped table-hover table-bordered ">
          <thead>
            <tr>
              {filterColumn?.map((each) => (
                <th style={{ textTransform: "capitalize" }}>{each}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {report.length > 0 ? (
              report.map((eachReport, i) => {
                return (
                  <tr>
                    {filterColumn.map((eachColumn) => (
                      <td>
                        {eachColumn === "lockedAt"
                          ? new Date(
                              eachReport[eachColumn],
                            ).toLocaleDateString()
                          : eachReport[eachColumn]}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <p>There is no Data</p>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
